'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapPartial = exports.PREFIX = undefined;

var _partial2 = require('lodash/partial');

var _partial3 = _interopRequireDefault(_partial2);

var _mapValues2 = require('lodash/mapValues');

var _mapValues3 = _interopRequireDefault(_mapValues2);

var _isString2 = require('lodash/isString');

var _isString3 = _interopRequireDefault(_isString2);

var _isObject2 = require('lodash/isObject');

var _isObject3 = _interopRequireDefault(_isObject2);

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _isArray2 = require('lodash/isArray');

var _isArray3 = _interopRequireDefault(_isArray2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _has2 = require('lodash/has');

var _has3 = _interopRequireDefault(_has2);

var _curry2 = require('lodash/curry');

var _curry3 = _interopRequireDefault(_curry2);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.createPrefix = createPrefix;
exports.getMeta = getMeta;
exports.preventDefault = preventDefault;
exports.createPayload = createPayload;
exports.createAction = createAction;
exports.roundNumber = roundNumber;
exports.getProgress = getProgress;

var _capeRedux = require('cape-redux');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var PREFIX = exports.PREFIX = 'default';

function createPrefix(prefix) {
  if ((0, _isString3.default)(prefix)) {
    return prefix.split('.');
  }

  if ((0, _isArray3.default)(prefix) && !(0, _isEmpty3.default)(prefix)) {
    return prefix;
  }

  if ((0, _isObject3.default)(prefix) && prefix.fieldId && prefix.formId) {
    return [prefix.formId, prefix.fieldId];
  }

  return [PREFIX];
}

function getMeta(prefixRaw, payload, extraMeta) {
  var prefix = createPrefix(prefixRaw);
  return (0, _isObject3.default)(extraMeta) ? _extends({}, extraMeta, {
    prefix: prefix
  }) : {
    prefix: prefix
  };
}

function preventDefault(event) {
  if (event && event.preventDefault) event.preventDefault();
}

function createPayload(prefix, payload) {
  if (!payload) return payload;
  preventDefault(payload);

  if (payload.target && payload.nativeEvent) {
    return payload.target.value || '';
  }

  return (0, _capeRedux.getPayload)(payload);
}

function createAction(type) {
  var hasPayload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return (0, _capeRedux.createAction)(type, hasPayload ? createPayload : _noop3.default, getMeta);
}

function roundNumber(progress, total) {
  return parseInt(progress / total * 100, 10);
}

function getProgress(value) {
  if ((0, _isObject3.default)(value)) {
    var hasProp = (0, _partial3.default)(_has3.default, value);
    if (hasProp('loaded') && hasProp('total')) return roundNumber(value.loaded, value.total);

    if (hasProp('bytesTransferred') && hasProp('totalBytes')) {
      return roundNumber(value.bytesTransferred, value.totalBytes);
    }
  }

  return parseInt(value, 10);
}

var mapPartial = exports.mapPartial = (0, _curry3.default)(function (obj, arg0) {
  return (0, _mapValues3.default)(obj, function (func) {
    return (0, _partial3.default)(func, arg0);
  });
});